// ================================================================================
// script.js
// 案件用のスクリプトファイル
// ================================================================================

// Member Redirection
// --------------------------------------------------------------- //

$(function() {
	if ( $('body').hasClass('front-page') ) {

		let $hash = location.hash;
		let $url = location.href;
		let $ret = $hash.replace('#', '');

		if ( $hash ) {
			if ( $url.indexOf('en/') != -1 ) {
				location.href = '/en/members/' + $ret;
			} else {
				location.href = '/members/' + $ret;
			}
		}

	}
});



// DOM Read for Vanilla
// --------------------------------------------------------------- //

document.addEventListener('DOMContentLoaded', () => {

	// breakpoint
	const breakpoint = window.matchMedia( 'screen and (min-width: 960px)' )

	// scroll volume
	function getScrolled() {
		return ( window.pageYOffset !== undefined ) ? window.pageYOffset: document.documentElement.scrollTop;
	}



	// variable
	// --------------------------------------------------------------- //

	// scroll
	let scrollTop = window.pageYOffset

	// url
	let url = location.href



	// Cookie Popup
	// --------------------------------------------------------------- //

	const $cookiePop = $('#cookie-notice');

	if ( $cookiePop ) {
		if ( url.indexOf('/en') != -1) {
			let $cookieDesc = $('#cn-notice-text');
			let $cookieAccept = $('#cn-accept-cookie');
			let $cookieRefuse = $('#cn-refuse-cookie');

			$cookieDesc.text('We use Google Analytics cookies to help us improve how our website is being used.  We will only collect cookies from you if you agree.')
			$cookieAccept.text('Accept all cookies')
			$cookieRefuse.text('Reject all cookies')
		}
	}




	// Dropdown for mobile
	// --------------------------------------------------------------- //

	const dropDownButton = document.getElementById('js-mobile-menu')
	const menuOpenTarget = document.querySelector('body')
	//const dropDownMenu   = document.getElementById('js-site-menu')

	if ( dropDownButton ) {
		dropDownButton.addEventListener('click', function() {
			dropDownButton.classList.toggle('is-close')
			menuOpenTarget.classList.toggle('is-menu-open')
			//dropDownMenu.classList.toggle('is-active')
		} )
	}



	// Lang Switcher
	// --------------------------------------------------------------- //

	const langToggle = document.getElementById('lang-toggle')
	const langContent = document.getElementById('lang-container')

	if ( langToggle ) {
		langToggle.addEventListener('click', function() {
			langToggle.classList.toggle('is-active')
			langContent.classList.toggle('is-active')
		} )
	}



	// Search bar
	// --------------------------------------------------------------- //

	const searchBar = document.getElementById('js-search-bar')
	const searchInput = document.getElementById('js-search-input')
	const searchMobileButton = document.getElementById('js-mobile-search-button')
	const searchButton = document.getElementById('js-search-button')

	if ( searchMobileButton && searchButton ) {
		searchMobileButton.addEventListener('click', function() {
			searchToggle()
		} )

		searchButton.addEventListener('click', function() {
			searchToggle()
		} )
	}

	function searchToggle() {
		searchBar.classList.toggle('is-active')
		searchMobileButton.classList.toggle('is-active')
		searchButton.classList.toggle('is-active')
		searchInput.focus()
	}



	// tab
	// --------------------------------------------------------------- //

	const tabItem = document.querySelectorAll('.js-tab-link')
	let tabContentItem = document.querySelectorAll('.js-tab-content-item')

	for ( let i = 0; i < tabItem.length; i++) {
		tabItem[i].addEventListener('click', function(event) {

			if ( tabItem[i].classList.contains('is-active') ) {
				event.stopPropagation()
				event.preventDefault()
			} else {
				let tabId = tabItem[i].getAttribute('id')
				tabId = tabId.replace('tab-', '')
				let targetContent = document.getElementById(tabId)

				for ( let j = 0; j < tabItem.length; j++) {
					tabItem[j].classList.remove('is-active')
				}
				for ( let i = 0; i < tabContentItem.length; i++) {
					tabContentItem[i].classList.remove('is-active')
				}

				tabItem[i].classList.add('is-active')
				targetContent.classList.add('is-active')

				event.stopPropagation()
				event.preventDefault()
			}


		});
	}

} );


// Recruit
// --------------------------------------------------------------- //
$(function() {

	$('.r-message__item--tab').on('click', function () {

		var index = $('.r-message__item--tab').index(this);
		$('.r-message__title').removeClass("r-message__title--active");
		$('.r-message__title').eq(index).addClass("r-message__title--active");
		$('.r-message__detal').removeClass("r-message__detal--active");
		$('.r-message__detal').eq(index).addClass("r-message__detal--active");

		// スマホサイズ（例: 768px 以下）の場合のみページ上部へスクロール
		if (window.innerWidth <= 768) {
			$('html, body').animate({ scrollTop: 0 }, 'slow');
		}

	});

	$('.js-r-message-detal').on('click', function () {

		console.log('aa');
		var $num = $(this).data('id');

		$('.r-message__title').removeClass("r-message__title--active");
		$('.r-message__detal').removeClass("r-message__detal--active");

		$('.r-message__title').eq($num).addClass("r-message__title--active");
		$('.r-message__detal').eq($num).addClass("r-message__detal--active");

		// スマホサイズ（例: 768px 以下）の場合のみページ上部へスクロール
		if (window.innerWidth <= 768) {
			$('html, body').animate({ scrollTop: 0 }, 'slow');
		}

		return false;

	});

});

